/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { SessionState as ISessionState } from 'client-code/session-manager';

export class SessionState {
    /**
     * The time (UTC) when the client must stop the streaming session.
     * This value is interpreted within the context of the original broadcast timeline.
     * When the client is streaming the broadcast at the live point (live-streaming),
     * the stream must stop at the specified time. When the client is streaming from a buffer,
     * the stream must stop when it reaches the specified time in the timeline of
     * the original broadcast, irrespective of the client's clock time.
     * @type {string}
     */
    linearPlaybackTerminateTime?: string;

    /**
     * Reason why the client must terminate the stream at the linearPlaybackTerminateTime.
     * @type {string}
     */
    linearPlaybackTerminateTimeReason?: string;

    /**
     * The unique ID of the session.
     * @type {string}
     */
    sessionId: string;

    /**
     * The status of the session.
     * @type {string}
     */
    status: string;

    constructor(params: ISessionState) {
        this.linearPlaybackTerminateTime = params.linearPlaybackTerminateTime;
        this.linearPlaybackTerminateTimeReason = params.linearPlaybackTerminateTimeReason;
        this.sessionId = params.sessionId;
        this.status = params.status;
    }
}
